import { createSelector } from "reselect";
import { getMinTime } from "../shared";

const useShiftForm = createSelector(
  [state => state.calendar.shiftForm],
  shiftForm => ({
    ...shiftForm,
    shifts: [...shiftForm.shifts].map(shift => ({
      ...shift,
      startTime: getMinTime(shift)
    }))
  })
);

export const mapStateToProps = state => ({
  shiftForm: useShiftForm(state)
});
